/**
 * Small UPS create/update payload helpers (#996 Phase 1).
 */

import type { SmallUpsConfiguration } from '../types/smallUps';

/** Strip server metadata before POST /requests/:id/small-ups */
export function toCreateSmallUpsPayload(
  unit: SmallUpsConfiguration,
): Omit<SmallUpsConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    ...payload
  } = unit;
  return payload;
}
